import { ConfirmProvider as ConfirmProviderContext } from 'material-ui-confirm';
import { POPUP_DEFAULT_STYLES } from './styles';

const ConfirmProvider: React.FC = ({ children }) => (
  <ConfirmProviderContext defaultOptions={POPUP_DEFAULT_STYLES}>{children}</ConfirmProviderContext>
);

export default ConfirmProvider;
